import {CmResource} from './CmResource';
export default CmResource;
